<template>
  <li class="time-block">
    <!-- Timeline visual indicator -->
    <div class="line-block">
      <div
        class="circle"
        :class="{ found: isFound }"
      >
        <img
          :src="nodeIcon"
          aria-hidden="true"
          draggable="false"
        >
      </div>
      <div class="line">
        <img :src="lineIcon" alt="">
      </div>
    </div>

    <!-- Timeline content (when unlocked) -->
    <div v-if="isUnlocked" class="content-time">
      <h3 :class="{ found: isFound }">
        {{ timeline.eventTime }}
      </h3>
      <p
        :class="{ found: isFound }"
        v-html="timelineContent"
      />
      <!-- Show find clue button only if NOT found yet -->
      <div
        v-if="isFound"
        @click="handleFindClue"
        class="clue"
      >
        <img :src="findClueIcon" />
      </div>
    </div>

    <!-- Locked state -->
    <div v-else>
      <img :src="lockIcon" class="lock-image" />
    </div>
  </li>
</template>

<script>
export default {
  name: 'TimelineItem',
  props: {
    timeline: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isUnlocked: {
      type: Boolean,
      default: false
    },
    isFound: {
      type: Boolean,
      default: false
    },
    nodeIcon: {
      type: String,
      default: ''
    },
    lineIcon: {
      type: String,
      default: ''
    },
    lockIcon: {
      type: String,
      default: ''
    },
    findClueIcon: {
      type: String,
      default: ''
    },
    timelineContent: {
      type: String,
      default: ''
    }
  },
  emits: ['find-clue'],
  methods: {
    handleFindClue() {
      this.$emit('find-clue', this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.time-block {
  position: relative;
  display: flex;
  padding-left: 22px;
  margin: 0;

  .line-block {
    position: absolute;
    left: 0;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;

    .circle {
      width: 22px;
      height: 22px;
      position: relative;
      z-index: 2;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .line {
      flex: 1;
      width: 3px;
      margin: 0 auto;

      > img {
        height: 100%;
      }
    }
  }

  .lock-image {
    margin-top: -25px;
  }

  .content-time {
    padding-bottom: 30px;
    margin-left: 15px;
    width: 280px;
    flex-shrink: 0;

    h3 {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 24px;

      &.found {
        color: #a43737;
      }
    }

    p {
      font-size: 16px;

      &.found {
        color: #a43737;
        margin-bottom: 16px;
      }
    }

    .clue {
      text-align: right;

      img {
        width: 70px;
      }
    }
  }
}
</style>